export interface IViewAllClaims {
  approvalRequestId: string;
  referenceNo: string;
  drName: string;
  assignedTo: string;
  beneficiary: {
    memberId: string;
    patientFileNo: string;
    nationalityNameEnglish: string;
    nationalityNameArabic: string;
  },
  approvalMainCareTeam: {
    nameEnglish: string;
    nameArabic: string;
    physicianId: string;
  },
  approvalItems: IViewClaimApprovalItem[],
  claimDate: string;
  totalNet: string;
  statusId: string;
  statusNameEnglish: string;
  statusNameArabic: string;
  attachmentStatus: string;
  pbmStatus: string;
  mreStatus: string;
  approvalSubmittedDate: string;
  responseDate: string;
  processingStatus: string;
  inquiry: string;
  reissued: string;
  uploadId: string;
  isClaimActive: boolean;
  isPaymentCreated: boolean;
  approvalType: string;
  isClaimReimbursement: boolean;
}

export interface IViewClaimApprovalItem {
  statusId: string;
  isItemReSubmitted: boolean,
  isItemReAdjudicated: boolean,
}

export const viewClaimsConfig = { entityName: "CLAIM.CLAIM" };

export interface IStatisticsData {
  uploadId: string
  uploadName: string
  uploadDate: string
  claimUploadDetailsByStatus: IClaimUploadDetailsByStatus[]
}

interface IClaimUploadDetailsByStatus {
  statusId: string
  statusNameEnglish: string
  statusNameArabic: string
  totalClaim: number
  totalNet: number
  activeClaims: number;
  inActiveClaims: number;
  totalTax: number
  totalPatientShare: number
  totalPayerShare: number
}

export interface IRevalidateResponse {
  ValidatedClaims: number,
  UnvalidatedClaims: number
}

export const viewClaimConfig = { entityName: "CLAIM.VIEW_CLAIMS.TITLE" };